import type { RouterInputs, RouterOutputs } from "@papier/api";

export type ProjectOutput = RouterOutputs["projects"]["getAll"][number];
export type ProjectBySlugOutput = RouterOutputs["projects"]["getBySlug"];

export type EnvironmentOutput = ProjectBySlugOutput["environments"][number];

export type ProjectTemplateOutput = RouterOutputs["templates"]["getAllWithUserDrafts"][number];

export type TemplatePreviewOutput = RouterOutputs["templates"]["getPublishedTemplate"];

export type ApiKeyOutput = RouterOutputs["apiKeys"]["getAll"][number];

export type SendingDomainOutput = RouterOutputs["messaging"]["listDomains"][number];
export type ProviderConnectionOutput = RouterOutputs["messaging"]["listConnections"][number];
export type DeliverySettingOutput = RouterOutputs["messaging"]["getDelivery"][number];
export type PushSubscriptionOutput = RouterOutputs["messaging"]["listSubscriptions"][number];
export type SuppressionOutput = RouterOutputs["messaging"]["listSuppressions"][number];
export type MessagingUsageOutput = RouterOutputs["messaging"]["getUsage"];

export type UserOutput = RouterOutputs["authTrpc"]["getAdminUsers"]["users"][number];
export type GetAdminUsersInput = RouterInputs["authTrpc"]["getAdminUsers"];

export type OrganizationOutput =
  RouterOutputs["authTrpc"]["getAdminOrganizations"]["organizations"][number];
export type GetAdminOrganizationsInput = RouterInputs["authTrpc"]["getAdminOrganizations"];

export type AdminUserActionsDialog =
  | "role"
  | "setPassword"
  | "revokeSessions"
  | "ban"
  | "unban"
  | "delete";

export type AdminOrgActionsDialog = "delete" | "add-members";

export const authViewPaths = {
  SIGN_IN: "sign-in",
  SIGN_UP: "sign-up",
  SIGN_OUT: "sign-out",
  MAGIC_LINK: "magic-link",
  FORGOT_PASSWORD: "forgot-password",
  RECOVER_ACCOUNT: "recover-account",
  CALLBACK: "callback",
  EMAIL_OTP: "email-otp",
  RESET_PASSWORD: "reset-password",
  TWO_FACTOR: "two-factor",
  ACCEPT_INVITATION: "accept-invitation",
  ORGANIZATION: "organization",
} as const;

export type AuthViewPath = (typeof authViewPaths)[keyof typeof authViewPaths];

export const nonAuthViews: AuthViewPath[] = [
  authViewPaths.SIGN_IN,
  authViewPaths.SIGN_UP,
  authViewPaths.MAGIC_LINK,
  authViewPaths.FORGOT_PASSWORD,
  authViewPaths.RECOVER_ACCOUNT,
  authViewPaths.CALLBACK,
];

export interface SchemaField {
  id: string;
  name: string;
  type: "string" | "number" | "boolean" | "object" | "date" | "enum" | "array";
  required: boolean;
  description?: string;
  enumValues?: string[];
  objectFields?: SchemaField[];
  arrayItemType?: SchemaField;
  examples?: any[];
  parentId?: string;
  parentType?: "object" | "array";
}

export interface Schema {
  id: string;
  name: string;
  schema: SchemaField[];
}
